<template>
  <v-app>
    <v-main class="surface main-app-container" id="desktop">
      <router-view/>
    </v-main>
    <div id="phone">   <v-card  width="100%" height="100vh" class="d-none flex-column justify-center align-center">
            <v-card-title class="ma-4 text-center word-break">
              Assessment taking on your mobile device is supported via mobile app. Kindly request the admin to send you the app installation invitation.</v-card-title> 
<!-- <a href="https://ssvgos.page.link/home">
          <v-btn class="blue ma-4" color="primarydty"
          
          
          x-large rounded  >
            Get App 
          </v-btn>
        </a> -->
    </v-card>
  </div>
 
  </v-app>
</template>

<script>
import "./styles.css";
import AuthService from "./services/AuthService";
import UserController from "@/controllers/UserController";
import sessionTimeoutMixin from "./mixins/sessionTimeoutMixin";
/* global faceapi */

export default {
  name: 'App',

  methods: {
    async getUserInfo() {
      const response = await UserController.getUserInfo();
      //console.log(response);
      if (!response || response.status == 401) {
        AuthService.logout();
      } else {
        this.$store.dispatch('setUserInfo', response.data.data)
      }
    },
    
    async loadModelProgressively(modelList) {
      console.time('[Proctoring] Total model load time');
      for (const modelName of modelList) {
        try {
          console.time(`[Proctoring] loadFromUri: ${modelName}`);
          await faceapi.nets[modelName].loadFromUri('/models');
          console.timeEnd(`[Proctoring] loadFromUri: ${modelName}`);

          // Verify the model is actually ready for inference
          if (faceapi.nets[modelName] && faceapi.nets[modelName].isLoaded) {
            console.log(`${modelName} verified as ready for inference`);
          } else {
            console.warn(`${modelName} loaded but not marked as ready`);
            // Wait a bit more for the model to be fully initialized
            await new Promise(resolve => setTimeout(resolve, 500));
          }
        } catch (error) {
          console.error(`Failed to load ${modelName}:`, error);
          // Handle error (e.g., try CPU, inform user)
          faceapi.tf.setBackend('cpu');
          // Attempt to reload this model using CPU
          await faceapi.nets[modelName].loadFromUri('/models');
        }
      }

      // Additional verification: perform a test inference to ensure models are ready
      try {
        const testCanvas = document.createElement('canvas');
        testCanvas.width = 100;
        testCanvas.height = 100;
        const testCtx = testCanvas.getContext('2d');
        testCtx.fillRect(0, 0, 100, 100);

        // Test that tinyFaceDetector is ready
        console.time('[Proctoring] Test inference');
        await faceapi.detectAllFaces(testCanvas, new faceapi.TinyFaceDetectorOptions({ minConfidence: 0.6 }));
        console.timeEnd('[Proctoring] Test inference');
        console.log('Models verified ready for inference');
      } catch (error) {
        console.warn('Model readiness test failed, but continuing:', error);
        // Wait a bit more before marking as loaded
        await new Promise(resolve => setTimeout(resolve, 500));
      }

      console.timeEnd('[Proctoring] Total model load time');
      this.$store.dispatch('setProctoringModelsLoaded', true);
    }

  },
  created() {
    if( AuthService.getUserId() ) {
      this.getUserInfo();
      AuthService.startPolling();
    }
    const modelList = ['faceRecognitionNet', 'faceLandmark68Net', 'tinyFaceDetector'];
    this.loadModelProgressively(modelList);
  },
  mixins: [sessionTimeoutMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (to.path !== '/dynamic-assessment') {
        vm.setupTimeout();
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    AuthService.stopPolling();
    this.clearTimeout();
    next();
  }
};
</script>
